// src/directives/swipeLeft.js
import Hammer from 'hammerjs';

export default {
  mounted(el, binding) {
    // Verificar si Hammer.js está disponible

    // Crear una instancia de Hammer.js para el elemento
    const hammerInstance = new Hammer(el);

    // Detectar el gesto de deslizamiento hacia la izquierda
    hammerInstance.on("swiperight", () => {
      const fakeEscapeEvent = { key: "Escape" }; // Evento simulado
      binding.value(fakeEscapeEvent); // Llama a la función pasada como valor
    });

    // Almacenar la instancia en el elemento para poder limpiarla después
    el._hammerInstance = hammerInstance;
  },
  unmounted(el) {
    // Destruir la instancia de Hammer.js cuando el elemento sea removido
    if (el._hammerInstance) {
      el._hammerInstance.destroy();
      delete el._hammerInstance;
    }
  },
};
